/**
 * System → Session Traces.
 *
 * Thin host over two views of the same telemetry: **Sessions** replays one
 * person's sitting, **Usage** aggregates across all of them. All state, filters
 * and queries live in the tab components.
 *
 * See docs/FeatureDesigns/user-actions.md and
 * docs/FeatureDesigns/user-activity-analytics.md.
 */

import { useState } from 'react';
import { TabStrip } from '@shared-ui/components';
import { UserActionSessionList } from './UserActionSessionList';
import { UsageTab } from './UsageTab';

type TabKey = 'sessions' | 'usage';

const TABS = [
  { key: 'sessions' as const, label: 'Sessions' },
  { key: 'usage' as const, label: 'Usage' },
];

export function UserActions() {
  const [tab, setTab] = useState<TabKey>('sessions');

  return (
    <div className="ua-page">
      <div className="ua-header">
        <h1>Session Traces</h1>
      </div>
      <TabStrip
        tabs={TABS}
        active={tab}
        onChange={key => setTab(key as TabKey)}
        ariaLabel="Session trace views"
      />
      {tab === 'sessions' ? <UserActionSessionList /> : <UsageTab />}
    </div>
  );
}
